module.exports = __webpack_public_path__ + "assets/images/icons/icon_virus-grey.svg?v=775a47cb";